import * as Types from '../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetHospitalByIdDocument = `
    query GetHospitalById($publicId: String!) {
  getHospitalByPublicId(publicId: $publicId) {
    id
    name
    isBookable
    isTodayBookable
    partnershipTemplate
    profileImages {
      url
      isRepresentative
    }
    badges
    naverPlaceDetail {
      hashtags
      treatmentMenus {
        treatmentName
        price
      }
    }
    temporaryHolidaysNotice
    temporaryHolidays
    todayDuty {
      dayOfWeek
      openTime
      closeTime
      breakStartTime
      breakEndTime
      operationTimes
      breakTimes
      isClosed
      operatingStatus
    }
    duties {
      dayOfWeek
      openTime
      closeTime
      breakStartTime
      breakEndTime
      operationTimes
      breakTimes
      isClosed
    }
    departmentsV2 {
      departmentId
      departmentName
    }
    departmentGroups {
      averageRating
      departmentGroupId
      departmentGroupName
      departmentGroupIconUrl
      tags
    }
    nonBenefitDiagnosisPrices {
      middleCategoryName
      minPrice
      maxPrice
    }
    longitude
    latitude
    jibunAddress
    roadAddress
    detailAddress
    directionGuidance
    parkingInformation
    isFreeParking
    tel
    viewCount
    introduction
    regionByDepth {
      siDoName
      siGunGuName
      eupMyeonDongName
    }
    treatments {
      id
      name
    }
    hospitalAdBanners {
      displayDiscount
      displayPrice
      id
      thumbnailImageUrl
      title
      url
      hospitalId
    }
    hospitalSurgeries {
      surgeryCount
      surgeryName
      badges
      id
    }
    doctors {
      id
      publicId
      hospitalId
      isAbsent
      name
      displayName
      medicineType
      gender
      profileImagePath
      contractType
      departmentGroups {
        departmentGroupId
        departmentGroupName
        departmentGroupIconUrl
        averageRating
      }
      professionalDepartmentsV2 {
        departmentId
        departmentName
        departmentCode
      }
      careers {
        careerType
        content
        id
      }
      reviewMetric {
        averageRating
        totalCount
        groupByDiagnosisType {
          count
          diagnosisType
          diagnosisTypeId
          name
        }
        groupByRating {
          count
          rating
        }
      }
      partnershipStatus
    }
    topRatedDoctorReviews(size: 3) {
      content
      createdAt
      id
      isPrivate
      likeCount
      maskedHolderName
      rating
      targetCategoryName
      title
      isBlocked
      isLiked
      comments {
        content
        createdAt
        id
        isBlocked
        reviewCommentHolder {
          id
          name
          profileImageUrl
        }
      }
      reviewContext {
        reviewReceiver {
          id
          name
        }
      }
      tags {
        id
        reviewId
        tag {
          tagId
          text
        }
        tagId
      }
    }
  }
}
    `;
export const useGetHospitalByIdQuery = <
      TData = Types.GetHospitalByIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetHospitalByIdQueryVariables,
      options?: UseQueryOptions<Types.GetHospitalByIdQuery, TError, TData>,
    ) =>
    useQuery<Types.GetHospitalByIdQuery, TError, TData>(
      ['GetHospitalById', variables],
      gqlFetcher<Types.GetHospitalByIdQuery, Types.GetHospitalByIdQueryVariables>(GetHospitalByIdDocument, 'GetHospitalById', variables),
      options
    );

useGetHospitalByIdQuery.getKey = (variables: Types.GetHospitalByIdQueryVariables) => ['GetHospitalById', variables];
;

useGetHospitalByIdQuery.fetcher = (variables: Types.GetHospitalByIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetHospitalByIdQuery, Types.GetHospitalByIdQueryVariables>(GetHospitalByIdDocument, 'GetHospitalById', variables, options);
export const DoctorReviewMetricDocument = `
    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {
  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {
    totalCount
    averageRating
    groupByRating {
      count
      rating
    }
    groupByDiagnosisType {
      diagnosisType
      diagnosisTypeId
      name
      count
    }
  }
}
    `;
export const useDoctorReviewMetricQuery = <
      TData = Types.DoctorReviewMetricQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.DoctorReviewMetricQueryVariables,
      options?: UseQueryOptions<Types.DoctorReviewMetricQuery, TError, TData>,
    ) =>
    useQuery<Types.DoctorReviewMetricQuery, TError, TData>(
      ['DoctorReviewMetric', variables],
      gqlFetcher<Types.DoctorReviewMetricQuery, Types.DoctorReviewMetricQueryVariables>(DoctorReviewMetricDocument, 'DoctorReviewMetric', variables),
      options
    );

useDoctorReviewMetricQuery.getKey = (variables: Types.DoctorReviewMetricQueryVariables) => ['DoctorReviewMetric', variables];
;

useDoctorReviewMetricQuery.fetcher = (variables: Types.DoctorReviewMetricQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.DoctorReviewMetricQuery, Types.DoctorReviewMetricQueryVariables>(DoctorReviewMetricDocument, 'DoctorReviewMetric', variables, options);
export const GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = `
    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {
  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {
    hospital {
      name
    }
    doctor {
      name
      medicineType
    }
    booking {
      status
    }
    diagnosis {
      status
    }
    bookingId
    targetDate
    targetDateDisplayText
    detailSymptom
    name
    registrationNumber
    address
    detailAddress
  }
}
    `;
export const useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = <
      TData = Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables,
      options?: UseQueryOptions<Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQuery, TError, TData>,
    ) =>
    useQuery<Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQuery, TError, TData>(
      ['GetFaceToFaceDiagnosisBookingFormByPublicId', variables],
      gqlFetcher<Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQuery, Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables>(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, 'GetFaceToFaceDiagnosisBookingFormByPublicId', variables),
      options
    );

useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = (variables: Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables) => ['GetFaceToFaceDiagnosisBookingFormByPublicId', variables];
;

useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = (variables: Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQuery, Types.GetFaceToFaceDiagnosisBookingFormByPublicIdQueryVariables>(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, 'GetFaceToFaceDiagnosisBookingFormByPublicId', variables, options);
export const GetTotalReviewCountWithAverageRatingByPublicIdDocument = `
    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {
  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {
    averageRating
    totalCount
  }
}
    `;
export const useGetTotalReviewCountWithAverageRatingByPublicIdQuery = <
      TData = Types.GetTotalReviewCountWithAverageRatingByPublicIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables,
      options?: UseQueryOptions<Types.GetTotalReviewCountWithAverageRatingByPublicIdQuery, TError, TData>,
    ) =>
    useQuery<Types.GetTotalReviewCountWithAverageRatingByPublicIdQuery, TError, TData>(
      ['GetTotalReviewCountWithAverageRatingByPublicId', variables],
      gqlFetcher<Types.GetTotalReviewCountWithAverageRatingByPublicIdQuery, Types.GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables>(GetTotalReviewCountWithAverageRatingByPublicIdDocument, 'GetTotalReviewCountWithAverageRatingByPublicId', variables),
      options
    );

useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = (variables: Types.GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables) => ['GetTotalReviewCountWithAverageRatingByPublicId', variables];
;

useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = (variables: Types.GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetTotalReviewCountWithAverageRatingByPublicIdQuery, Types.GetTotalReviewCountWithAverageRatingByPublicIdQueryVariables>(GetTotalReviewCountWithAverageRatingByPublicIdDocument, 'GetTotalReviewCountWithAverageRatingByPublicId', variables, options);
export const GetAddressByLocationDocument = `
    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {
  getAddressByLocation(longitude: $longitude, latitude: $latitude) {
    detailAddress
    jibunAddress
    roadAddress
    sido
    zipCode
    sigungu
    dongLi
  }
}
    `;
export const useGetAddressByLocationQuery = <
      TData = Types.GetAddressByLocationQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetAddressByLocationQueryVariables,
      options?: UseQueryOptions<Types.GetAddressByLocationQuery, TError, TData>,
    ) =>
    useQuery<Types.GetAddressByLocationQuery, TError, TData>(
      ['GetAddressByLocation', variables],
      gqlFetcher<Types.GetAddressByLocationQuery, Types.GetAddressByLocationQueryVariables>(GetAddressByLocationDocument, 'GetAddressByLocation', variables),
      options
    );

useGetAddressByLocationQuery.getKey = (variables: Types.GetAddressByLocationQueryVariables) => ['GetAddressByLocation', variables];
;

useGetAddressByLocationQuery.fetcher = (variables: Types.GetAddressByLocationQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetAddressByLocationQuery, Types.GetAddressByLocationQueryVariables>(GetAddressByLocationDocument, 'GetAddressByLocation', variables, options);
export const GetUserAddressesDocument = `
    query GetUserAddresses {
  getUserAddresses {
    userAddressId
    userId
    alias
    roadAddress
    oldAddress
    detailAddress
    addressType
    location {
      latitude
      longitude
    }
    zipCode
    deliveryComment
    frontDoorPassword
    isDefault
  }
}
    `;
export const useGetUserAddressesQuery = <
      TData = Types.GetUserAddressesQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.GetUserAddressesQueryVariables,
      options?: UseQueryOptions<Types.GetUserAddressesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetUserAddressesQuery, TError, TData>(
      variables === undefined ? ['GetUserAddresses'] : ['GetUserAddresses', variables],
      gqlFetcher<Types.GetUserAddressesQuery, Types.GetUserAddressesQueryVariables>(GetUserAddressesDocument, 'GetUserAddresses', variables),
      options
    );

useGetUserAddressesQuery.getKey = (variables?: Types.GetUserAddressesQueryVariables) => variables === undefined ? ['GetUserAddresses'] : ['GetUserAddresses', variables];
;

useGetUserAddressesQuery.fetcher = (variables?: Types.GetUserAddressesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetUserAddressesQuery, Types.GetUserAddressesQueryVariables>(GetUserAddressesDocument, 'GetUserAddresses', variables, options);
export const SearchKoreaAddressV2Document = `
    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {
  searchKoreaAddressV2(request: $request) {
    centroidLatitude
    centroidLongitude
    displayName
    regionCode
    regionName
  }
}
    `;
export const useSearchKoreaAddressV2Query = <
      TData = Types.SearchKoreaAddressV2Query,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchKoreaAddressV2QueryVariables,
      options?: UseQueryOptions<Types.SearchKoreaAddressV2Query, TError, TData>,
    ) =>
    useQuery<Types.SearchKoreaAddressV2Query, TError, TData>(
      ['SearchKoreaAddressV2', variables],
      gqlFetcher<Types.SearchKoreaAddressV2Query, Types.SearchKoreaAddressV2QueryVariables>(SearchKoreaAddressV2Document, 'SearchKoreaAddressV2', variables),
      options
    );

useSearchKoreaAddressV2Query.getKey = (variables: Types.SearchKoreaAddressV2QueryVariables) => ['SearchKoreaAddressV2', variables];
;

useSearchKoreaAddressV2Query.fetcher = (variables: Types.SearchKoreaAddressV2QueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchKoreaAddressV2Query, Types.SearchKoreaAddressV2QueryVariables>(SearchKoreaAddressV2Document, 'SearchKoreaAddressV2', variables, options);
export const HospitalExternalPostDocument = `
    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {
  hospitalExternalPost(
    hospitalPublicId: $hospitalPublicId
    size: $size
    pivotId: $pivotId
  ) {
    totalCount
    items {
      id
      title
      content
      postedAt
      url
    }
  }
}
    `;
export const useHospitalExternalPostQuery = <
      TData = Types.HospitalExternalPostQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.HospitalExternalPostQueryVariables,
      options?: UseQueryOptions<Types.HospitalExternalPostQuery, TError, TData>,
    ) =>
    useQuery<Types.HospitalExternalPostQuery, TError, TData>(
      ['HospitalExternalPost', variables],
      gqlFetcher<Types.HospitalExternalPostQuery, Types.HospitalExternalPostQueryVariables>(HospitalExternalPostDocument, 'HospitalExternalPost', variables),
      options
    );

useHospitalExternalPostQuery.getKey = (variables: Types.HospitalExternalPostQueryVariables) => ['HospitalExternalPost', variables];
;

useHospitalExternalPostQuery.fetcher = (variables: Types.HospitalExternalPostQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.HospitalExternalPostQuery, Types.HospitalExternalPostQueryVariables>(HospitalExternalPostDocument, 'HospitalExternalPost', variables, options);